import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { FormUtils } from '@rx-applications/shared/utils-forms';
import { AuthFacade, AuthLoggerService, AuthRoutes } from '@rx-applications/shared/auth/data-access';
import { addAbsolutePathPrefix } from '@rx-applications/shared/utils';
import { CommonModule } from '@angular/common';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';
import { TranslocoModule } from '@ngneat/transloco';
import { RxAlertModule, RxButtonModule, RxInputModule } from '@roomex/rx-components';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PasswordMatchFormComponent, PasswordPolicyComponent } from '@rx-applications/shared/auth/ui';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'rx-reset-password',
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    RxButtonModule,
    RouterLink,
    RxAlertModule,
    ReactiveFormsModule,
    PasswordMatchFormComponent,
    RxInputModule,
    PasswordPolicyComponent,
  ],
  providers: [translationProvider],
})
export class ResetPasswordComponent extends FormUtils implements OnDestroy {
  protected readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;
  protected readonly addAbsolutePathPrefix = addAbsolutePathPrefix;
  protected readonly confirmationCode = this.route.snapshot.queryParamMap.get('i');
  protected readonly email = this.route.snapshot.queryParamMap.get('email');

  authRoutes = AuthRoutes;

  form: UntypedFormGroup;

  constructor(
    public authFacade: AuthFacade,
    private fb: UntypedFormBuilder,
    private authLoggerService: AuthLoggerService,
    private route: ActivatedRoute
  ) {
    super();
    this.form = this.fb.group({
      confirmationCode: this.fb.control(this.confirmationCode, [Validators.required]),
    });

    this.authFacade.clearUserSession();
  }

  ngOnDestroy() {
    // When a user reset password and then, go to another route and come back
    // to the forgot password page, it shows the success notification. The
    // below action reset the state when component is destroyed.
    this.authFacade.hideSuccessMessage();
    this.authFacade.hideErrorMessage();
  }

  onSubmit() {
    this.authLoggerService.clickedOnReset();
    if (this.form.invalid) {
      this.markAllAsTouched(this.form);
      return;
    }

    this.authFacade.resetPassword(this.form.value.confirmationCode, this.form.value.password);
  }
}
